export default __webpack_public_path__ + "static/media/surf.82174df4.svg";